import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface SectionTitleProps {
    title: string;
    seeAllLink?: string;
    disabled?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, seeAllLink, disabled = false }) => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '1200px',
                margin: '0 auto',
                px: { xs: 2, sm: 3, md: 2 },  // ✅ Reduced horizontal padding on desktop
                mt: { xs: 3, md: 4 },         // Top spacing
                mb: { xs: 1.5, md: 2 },       // Bottom spacing
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: '1.25rem', md: '1.5rem' }, // Consistent text size handling
                }}
            >
                {title}
            </Typography>
            {seeAllLink && !disabled && (
                <Button
                    variant="text"
                    onClick={() => navigate(seeAllLink)}
                    sx={{
                        color: '#FF69B4', // Pink color
                        textTransform: 'none',
                        fontWeight: 'bold',
                    }}
                >
                    See All
                </Button>
            )}
        </Box>
    );
};

export default SectionTitle;
